import React, { Component } from "react";

import ComponentSelector from "../utils/components/ComponentSelector";
import UserSessions from "./UserSessions";
import ChargerSessions from "./ChargerSessions";

import "../../styles/components/sessions/Sessions.scss";

class Sessions extends Component {
  constructor(props) {
    super(props);
    this._mounted = false;

    this.state = {};
  }

  componentDidMount() {
    this._mounted = true;
  }

  componentWillUnmount() {
    this._mounted = false;
  }

  safeSetState(params, callback) {
    if (this._mounted) this.setState(params, callback);
  }

  render() {
    return (
      <div id="sessions" className="evio-container sidebar-fix main-component">
        <ComponentSelector
          tabs={[
            { title: "label_sessions", component: <UserSessions /> },
            {
              title: "sessions_myChargerSessions",
              component: <ChargerSessions />
            }
          ]}
        />
      </div>
    );
  }
}

export default Sessions;
